var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-pin",
    transform: "translate(1653 -28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_971",
    "data-name": "Rectangle 971",
    width: 37,
    height: 37,
    transform: "translate(-1653 28)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(-1650.038 32.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5878",
    "data-name": "Path 5878",
    d: "M16.759,17.768a4.384,4.384,0,1,1,4.384-4.384,4.384,4.384,0,0,1-4.384,4.384Zm0-7.015a2.631,2.631,0,1,0,2.631,2.631,2.631,2.631,0,0,0-2.631-2.631Z",
    transform: "translate(-1.489 -1.489)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5879",
    "data-name": "Path 5879",
    d: "M15.27,26.8l-7.4-8.724q-.154-.2-.3-.4A9.548,9.548,0,0,1,5.625,11.9a9.645,9.645,0,1,1,19.291,0,9.544,9.544,0,0,1-1.942,5.785v0s-.263.345-.3.392Zm-6.3-10.176s.2.27.252.328l6.051,7.137,6.059-7.147c.038-.048.244-.32.245-.321A7.805,7.805,0,0,0,23.162,11.9a7.892,7.892,0,1,0-15.783,0,7.808,7.808,0,0,0,1.59,4.73Z",
    transform: "translate(0 0)",
    fill: "#c1c1c1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon-pin.55d848f32f2ca17f879d9fe816d9f43d.svg";
export { ForwardRef as ReactComponent };